const billetType = {
  SIMPLE: 'SIMPLES',
  COLLECTION: 'ARRECADACAO'
};

module.exports = billetType;
